export default __webpack_public_path__ + "static/media/pavlosp.4f8f17a4.svg";